'use strict';

var angularModule = angular.module('t2g.common.services.sse', []);

module.exports = angularModule;

angularModule.factory('SseService', function (settings) {
  const notificationEventSource = new EventSource(settings.apiBase + '/api/v2/sse/notification');

  return {
    notificationEventSource
  };
});
